import React, { useState } from "react";
import { motion } from "framer-motion";
import { CalendarDays, User, ExternalLink } from "lucide-react";
import { fileUrl } from "../lib/api";

export default function WorkshopsSection({ workshops, content }) {
  const [tab, setTab] = useState("upcoming");
  const filtered = workshops.filter((w) => w.status === tab);

  return (
    <section id="workshops" data-testid="workshops-section" className="py-20 bg-[#1A0F0E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-10">
          <div className="text-[#F0E8DB] text-xs tracking-[0.4em] font-serif-en mb-3">EVENTS &amp; COURSES</div>
          <h2 className="section-title text-3xl sm:text-4xl">{content.titles.workshops}</h2>
        </div>

        <div className="flex justify-center gap-2 mb-10">
          {[
            { k: "upcoming", label: "القادمة" },
            { k: "past", label: "السابقة" },
          ].map((t) => (
            <button
              key={t.k}
              data-testid={`workshop-tab-${t.k}`}
              onClick={() => setTab(t.k)}
              className={`px-6 py-2 rounded-full text-sm border transition ${
                tab === t.k
                  ? "bg-[#7A2E2A] border-[#F0E8DB] text-[#F0E8DB]"
                  : "border-[#F0E8DB]/25 text-[#C5B8A8] hover:border-[#F0E8DB]/60"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <p className="text-center text-[#A89A88] py-10">لا توجد {tab === "upcoming" ? "فعاليات قادمة" : "فعاليات سابقة"} حالياً.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((w, i) => (
              <motion.div
                key={w.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`workshop-card-${w.id}`}
                className="theater-card rounded-2xl overflow-hidden"
              >
                {w.image_url && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={fileUrl(w.image_url)} alt={w.title} className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-5">
                  <h3 className="text-[#F0E8DB] text-lg font-semibold mb-2">{w.title}</h3>
                  <p className="text-[#A89A88] text-sm mb-4 line-clamp-3">{w.description}</p>
                  <div className="flex flex-wrap gap-3 text-xs text-[#BFB3A0] mb-4">
                    {w.date && <span className="flex items-center gap-1"><CalendarDays size={12} />{w.date}</span>}
                    {w.instructor && <span className="flex items-center gap-1"><User size={12} />{w.instructor}</span>}
                  </div>
                  {tab === "upcoming" && w.register_url && (
                    <a
                      href={w.register_url}
                      target="_blank"
                      rel="noreferrer"
                      data-testid={`workshop-register-${w.id}`}
                      className="btn-gold rounded-full px-4 py-2 text-sm inline-flex items-center gap-1"
                    >
                      سجّل الآن <ExternalLink size={14} />
                    </a>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
